import { RouteRecordRaw } from 'vue-router'
import { metaDataAuthGuard } from '@shared/guards/auth'
import { AuthScope, PermissionLevel } from '@shared/stores/auth'
import type { ExtractRouteNames } from '@shared/types/RouteNames'
// components
const TradePortal = () => import(/* webpackChunkName: "TradePortal" */ '@trade-portal/views/TradePortal.vue')
const TradePortalManageUsers = () => import(/* webpackChunkName: "TradePortalManageUsers" */ '@trade-portal/views/TradePortalManageUsers.vue')
const TradePortalCustomiseTheme = () => import(/* webpackChunkName: "TradePortalCustomiseTheme" */ '@trade-portal/views/TradePortalCustomiseTheme.vue')
const TradePortalCustomiseEmails = () => import(/* webpackChunkName: "TradePortalCustomiseEmails" */ '@trade-portal/views/TradePortalCustomiseEmails.vue')
const TradePortalLoading = () => import(/* webpackChunkName: "TradePortalLoading" */ '@trade-portal/views/TradePortalLoading.vue')
const TradePortalConfigOverview = () => import(/* webpackChunkName: "TradePortalConfigOverview" */ '@trade-portal/views/TradePortalConfigOverview.vue')
const TradePortalCustomiseProducts = () => import(/* webpackChunkName: "TradePortalCustomiseProducts" */ '@trade-portal/views/TradePortalCustomiseProducts.vue')
const TradePortalCustomiseStockSettings = () => import(/* webpackChunkName: "TradePortalCustomiseStockSettings" */ '@trade-portal/views/TradePortalCustomiseStockSettings.vue')
const TradePortalCustomiseOrderSettings = () => import(/* webpackChunkName: "TradePortalCustomiseOrderSettings" */ '@trade-portal/views/TradePortalCustomiseOrderSettings.vue')

// Support admin
export const routes = {
  path: '/trade-portal',
  name: 'TradePortal',
  redirect: { name: 'TradePortalLoading' },
  component: TradePortal,
  beforeEnter: metaDataAuthGuard,
  meta: {
    requiredScopes: [{ level: PermissionLevel.All, scope: AuthScope.TradePortal }],
  },
  children: [
    {
      path: 'loading',
      name: 'TradePortalLoading',
      component: TradePortalLoading,
      beforeEnter: metaDataAuthGuard,
    },
    {
      path: ':instanceName',
      redirect: { name: 'TradePortalConfigOverview' },
      children: [
        {
          path: 'config-overview',
          name: 'TradePortalConfigOverview',
          component: TradePortalConfigOverview,
          beforeEnter: metaDataAuthGuard,
        },
        {
          path: 'manage-users',
          name: 'TradePortalManageUsers',
          component: TradePortalManageUsers,
          beforeEnter: metaDataAuthGuard,
        },
        {
          path: 'customise-theme',
          name: 'TradePortalCustomiseTheme',
          component: TradePortalCustomiseTheme,
          beforeEnter: metaDataAuthGuard,
        },
        {
          path: 'customise-emails',
          name: 'TradePortalCustomiseEmails',
          component: TradePortalCustomiseEmails,
          beforeEnter: metaDataAuthGuard,
        },
        {
          path: 'customise-products',
          name: 'TradePortalCustomiseProducts',
          component: TradePortalCustomiseProducts,
          beforeEnter: metaDataAuthGuard,
        },
        {
          path: 'customise-stock',
          name: 'TradePortalCustomiseStockSettings',
          component: TradePortalCustomiseStockSettings,
          beforeEnter: metaDataAuthGuard,
        },
        {
          path: 'customise-order',
          name: 'TradePortalCustomiseOrderSettings',
          component: TradePortalCustomiseOrderSettings,
          beforeEnter: metaDataAuthGuard,
        },
      ],
    },
  ],
} as const satisfies RouteRecordRaw

export type TradePortalSettingsRouteNames = ExtractRouteNames<typeof routes> 
  | ExtractRouteNames<typeof routes.children[0]> 
  | ExtractRouteNames<Pick<Extract<typeof routes.children[number], { path: ':instanceName' }>, 'children'>['children'][number]>

export default routes
